




















































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import Passenger from "../models/Passenger";
import PassengerPhonenumberEditor from "./PassengerPhonenumberEditor.vue";
import Group from "../models/Group";
import GroupPicker from "@/components/Passenger/components/GroupPicker.vue";
import SsnEditor from "@/components/Passenger/components/SsnEditor.vue"
import IPassengerPhoneNumberViewModel from "../models/IPassengerPhoneNumberViewModel";
import MovitInstanceConfig from "@/models/MovitInstanceConfig";
import Destination from "../models/Destination";
import { User } from "@/models/User";
import restService from "@/services/restService";

@Component({
  components: {
    PassengerPhonenumberEditor,
    GroupPicker,
    SsnEditor,
  },
})
export default class PassengerDetailsEditor extends Vue {
  originalPhoneNumbers: IPassengerPhoneNumberViewModel[] = [];
  destinationGroups: Group[] = [];

  rules: any = {
    required: (value) =>
      !!value || this.$i18n.translate("validation.rules.required", "Required"),
    maxLength: (value) => this.validateEternalId(value) || this.$i18n.translate("validation.rules.externalIdLength", "External ID's max length is 128 characters."),
    postalCodeMaxlength: (value) => this.validatePostalCode(value) || this.$i18n.translate("validation.rules.postalCodeMaxLength", "Max length for postal code is 32 characters"),
    billingCityMaxLength: (value) => this.validateBillingCity(value) || this.$i18n.translate("validation.rules.billingCityMaxLength", "Max length for billing city is 32 characters."),
    billingNameMaxlength: (value: string) => this.validateBillingName(value) || this.$i18n.translate("validation.rules.billingNameMaxLength", "Max length for billing name is 128 characters."),
    
  };

  @Prop({ default: false }) private allowUserInput!: boolean;
  // @Prop({ required: true }) private value!: Passenger;
  @Prop({ default: false }) private saving!: boolean;
  @Prop({ default: false }) private deleting: boolean;
  @Prop({ default: () => null }) private passenger!: Passenger;

  async mounted() {
    this.originalPhoneNumbers = JSON.parse(JSON.stringify(this.passenger.phoneNumbers));
    if (this.passenger.id > 0) {
      this.destinationGroups = (await restService.passengers.getPassengerAvailableDestinationGroups(this.passenger.id))
        .map(groupName => {return new Group(groupName, false)})
    }
  }

  @Watch("saving")
  resetOriginalPhoneNumbers() {
    if (this.saving) {
      this.originalPhoneNumbers = JSON.parse(JSON.stringify(this.passenger.phoneNumbers))
    }
  }

  get me(): User {
    return this.$store.state.user.me;
  }

  get isEditing(): boolean {
    return this.passenger.id > 0;
  }

  get storeMovitInstanceConfigs(): MovitInstanceConfig[]{
    return this.$store.state.app.movitInstanceConfigs as MovitInstanceConfig[];
  }

  get passengersOrganizationId(): string {
    if (this.$route.params.organizationId) {
      return this.$route.params.organizationId;
    }
    // tslint:disable-next-line:max-line-length
    return this.$store.getters['passenger/passengerOrganizationId'](this.passenger.id, this.passenger.destinationIds) as string;
  }

  get showSsnToOrganization(): boolean {
    return this.$store.getters['auth/organizationCanSeeSsn'](this.passengersOrganizationId);
  }

  get canSeeSsn() {
    return this.passengersOrganizationId && this.showSsnToOrganization;
  }

  get showExternalId() {
    // Show external id editor only for passengers that belong to the Espoo organization 
    // or passenger destination is for Espoo organization
    const destinationIds = this.passenger.destinationIds;
    const allDestinations: Destination[] = this.$store.state.destination.destinations;
    const destinations = allDestinations.filter(d => destinationIds.includes(d.id) && d.organizationId);
    if (window.location.host.includes('staging') || window.location.host.includes('localhost')) {
      // tslint:disable-next-line:max-line-length
      return this.passenger.organizationId === '00ad7549-de39-4f76-87f0-ca933966a998' || destinations.some(d => d.organizationId && d.organizationId === '00ad7549-de39-4f76-87f0-ca933966a998');
    }

    const espooOrganizations: string[] = [
      '626a6858-8c19-4a69-b699-12e577ce012a'.toLowerCase(),
      '17dd2fb9-4253-4503-881d-f5cdb305ceaf'.toLowerCase()
    ];

    if (this.passenger.organizationId && espooOrganizations.includes(this.passenger.organizationId.toLowerCase())) {
      return true;
    }

    return destinations.some(d => d.organizationId && espooOrganizations.includes(d.organizationId.toLowerCase()));
  }

  get phoneNumbersChanged() {
    if (this.originalPhoneNumbers.length !== this.passenger.phoneNumbers.length) {
      return true;
    }

    let somethingChanged = false;
    this.originalPhoneNumbers.forEach((o, i) => {
      const target = this.passenger.phoneNumbers[i]
      if (o.number !== target.number || o.sms !== target.sms ||
        o.showToDriver !== target.showToDriver || o.assistant !== target.assistant) {
          somethingChanged = true;
         }
    })

    return somethingChanged;

  }

  validateEternalId(externalId: string) {
    if (!externalId) {
      return true;
    }
    return externalId.length <= 128;
  }

  validatePostalCode(postalCode: string) {
    if (!postalCode) {
      return true;
    }
    return postalCode.length <= 32;
  }

  validateBillingName(name: string) {
    if (!name) {
      return true;
    }
    return name.length <= 128;
  
  }

  validateBillingCity(postalCity: string) {
    if (!postalCity) {
      return true;
    }
    return postalCity.length <= 32;
  }

  tagsChanged(selectedGroups: Group[]) {
    this.passenger.groups = selectedGroups.map((g) => g.name).join(",");
  }

  saveSsn(id: number) {
    if (this.canSeeSsn) {
      (this.$refs.ssnEditor as any).saveSsn();
    }
  }

  getNewPassengerSsn() {
    if (this.canSeeSsn) {
      return (this.$refs.ssnEditor as any).getSsnForNewPassenger();
    }
  }
  async saveSsnForNewPassenger(id: number, ssn: string) {
    if (this.canSeeSsn) {
      await (this.$refs.ssnEditor as any).saveSsnForNewPassenger(id, ssn);
    }
  }
}
